import React from 'react';

export default function FullScreenLoader() {
  return (
    <svg
      className="loader pulse-loader"
      width="64"
      height="64"
      viewBox="0 0 360 360"
    >
      <path
        fill="#EB5C5B"
        d="M231.87,272.64c-12.13,17.74-36.34,22.29-54.08,10.16c-4.8-3.28-8.8-7.59-11.71-12.62L86.82,132.91L50.7,70.35 H38.74c-21.51,0-38.96,17.43-38.96,38.95c0,6.84,1.8,13.57,5.22,19.49l121.45,210.34c10.77,18.63,34.61,25.01,53.24,14.24 c5.91-3.42,10.82-8.33,14.24-14.24l74.49-129.03l46.99-81.31c0.34-0.6,0.6-1.22,0.89-1.83l-82.69,143.22 C233.06,271.06,232.46,271.84,231.87,272.64z"
      />
      <path
        fill="#55B5E7"
        d="M340.75,6.62C334.82,3.2,328.1,1.4,321.26,1.4H78.38c-15.83,0-29.45,9.44-35.54,23L10.97,81.92 c7.29-7.51,17.34-11.71,27.8-11.64h11.9l0.04,0.06h230.91c21.49,0.01,38.9,17.44,38.89,38.92c0,6.15-1.46,12.21-4.26,17.68 l38.75-67.12C365.76,41.21,359.38,17.38,340.75,6.62z"
      />
      <path
        fill="#6F68AC"
        d="M281.61,70.35H50.7l36.12,62.56l79.26,137.27c10.77,18.59,34.57,24.94,53.17,14.17 c5.03-2.91,9.34-6.91,12.62-11.71c0.55-0.81,1.14-1.57,1.64-2.46l82.69-143.22c9.78-19.14,2.19-42.57-16.95-52.35 C293.79,71.82,287.74,70.36,281.61,70.35z"
      />
    </svg>
  );
}
